import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { LoginService } from './components/login/service/login.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';

@Component({
  standalone: false,
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.component.html',
})
export class AppComponent {
  dateTime!: Date;
  userDetails: any;
  constructor(
    private readonly service: LoginService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    if (sessionStorage.getItem('isLoggedIn') && localStorage.getItem('user')) {
      localStorage.getItem('user');
      this.service.isAuthorizedUser = true;
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event?: any) {
    const url = window.location.pathname;
    if (url === '/login') {
      event.preventDefault();
      if (this.service.isAuthorizedUser) {
        history.go(1);
      }
    }
  }

  getUser() {
    this.service.getUser().subscribe({
      next: (response: any) => {
        if (response.hasOwnProperty('id') && response.is_active) {
          // was "userid", now "id" + check is_active
          this.service.isAuthorizedUser = true;
          this.userDetails = response;
          let data = CryptoJS.AES.encrypt(
            JSON.stringify(response),
            this.service.enCryptKey,
          );
          localStorage.setItem('user', data.toString());
          this.service.userDetails = response;

          this.router.navigate(['/dashboard']);
        } else {
          localStorage.clear();
          this.router.navigateByUrl('login');
        }
      },
      error: (error: HttpErrorResponse) => {
        localStorage.clear();
        this.router.navigateByUrl('login');
      },
    });
  }
}